import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { jmd } from "@/lib/format";
import { useCart } from "@/context/CartContext";

export default function FygaroReturn() {
  const [sp] = useSearchParams();
  const ref = sp.get("custom_reference") || sp.get("reference") || sp.get("order");
  const [st, setSt] = useState(null);
  const [tries, setTries] = useState(0);
  const { clear } = useCart();
  useEffect(() => {
    if (!ref) return;
    let stop = false;
    const poll = async () => { try { const { data } = await api.get(`/payments/fygaro/order/${encodeURIComponent(ref)}`); if (!stop) { setSt(data); if (data.payment_status === "paid") clear(); } } catch { if (!stop) setSt({ missing: true }); } };
    poll();
    const t = setInterval(() => { setTries((n) => n + 1); poll(); }, 3000);
    return () => { stop = true; clearInterval(t); };
  }, [ref]); // eslint-disable-line react-hooks/exhaustive-deps
  const paid = st?.payment_status === "paid";
  return (
    <div className="max-w-xl mx-auto px-4 py-16 text-center" data-testid="fygaro-return">
      {paid ? <CheckCircle2 size={56} className="mx-auto text-emerald" /> : <Clock size={56} className="mx-auto text-amber-500" />}
      <h1 className="font-display text-3xl font-bold mt-4" data-testid="fygaro-return-title">{paid ? "Payment confirmed" : "Confirming your payment…"}</h1>
      <p className="text-muted-foreground mt-2" data-testid="fygaro-return-status">
        {!ref ? "No payment reference was returned. If you paid, check your email or your orders page." : st?.missing ? `We don't recognise reference ${ref}.` : paid ? `Fygaro confirmed order ${ref}${st.total ? ` · ${jmd(st.total)}` : ""}. A receipt is on its way.` : `Fygaro is telling us about order ${ref}. This usually takes a few seconds — please don't pay again.`}
      </p>
      {!paid && ref && !st?.missing && <div className="mt-4 inline-flex items-center gap-2 text-xs text-muted-foreground"><Loader2 size={14} className="animate-spin" /> checking{tries > 6 ? " — still waiting on Fygaro's confirmation; your order stays reserved as pending" : ""}</div>}
      <div className="mt-8 flex justify-center gap-3">
        {ref && <Link to={`/track?order=${encodeURIComponent(ref)}`} className="rounded-xl bg-ink text-white px-5 py-2.5 text-sm font-semibold" data-testid="fygaro-return-track">Track order</Link>}
        <Link to="/" className="rounded-xl border border-border px-5 py-2.5 text-sm font-semibold">Continue shopping</Link>
      </div>
    </div>
  );
}
